// Permisos RBAC de Configuración global. Todo depende de `loan.parameter.read`: sin él la pantalla
// no carga, así que editar o auditar sin leer no habilita nada.

export const GLOBAL_CONFIG_PERMISSIONS = {
    read: 'loan.parameter.read',
    update: 'loan.parameter.update',
    audit: 'loan.parameter.audit',
} as const;

export interface GlobalConfigAbilities {
    canRead: boolean;
    canUpdate: boolean;
    canViewAudit: boolean;
}

/** Qué puede hacer el rol en la pantalla, a partir de `useAuth().permissions`. */
export function resolveGlobalConfigAbilities(granted: ReadonlySet<string>): GlobalConfigAbilities {
    const canRead = granted.has(GLOBAL_CONFIG_PERMISSIONS.read);
    return {
        canRead,
        canUpdate: canRead && granted.has(GLOBAL_CONFIG_PERMISSIONS.update),
        canViewAudit: canRead && granted.has(GLOBAL_CONFIG_PERMISSIONS.audit),
    };
}
